"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Cursor03 = function Cursor03(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4.7115 3.6745c-.5405-.213-.8108-.3195-.983-.2622a.5.5 0 0 0-.3167.3166c-.0572.1723.0492.4425.2622.9831l5.3006 13.4555c.1715.4353.2573.653.397.7404a.5.5 0 0 0 .4083.0551c.1579-.0472.2983-.2344.579-.6088l2.1407-2.8541 3.4493 4.7428c.1896.2607.2845.3911.4053.4456a.5.5 0 0 0 .3376.0265c.1278-.035.2418-.149.4698-.377l3.176-3.1759c.2279-.228.3419-.342.3769-.4698a.5.5 0 0 0-.0265-.3376c-.0545-.1209-.1848-.2157-.4456-.4053l-4.7428-3.4493 2.8542-2.1407c.3743-.2807.5615-.4211.6087-.579a.5.5 0 0 0-.0551-.4083c-.0874-.1397-.305-.2255-.7404-.397z"
    })
  }));
};
var _default = exports["default"] = Cursor03;